module.exports = __webpack_public_path__ + "media/bootstrap-icons/peace-fill-670ea7d3.svg";